import SidebarLink from '@/components/molecules/SidebarLink';
import React from 'react';
import Logo from '@/assets/images/logo512.png';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAppSelector } from '@/hooks/useAppSelector';

const USER_LINKS = [
  {
    label: 'Dashboard',
    iconKey: 'dashboard',
    path: 'dashboard'
  },
  {
    label: 'Budget',
    iconKey: 'budget',
    path: 'budgets'
  },

  {
    label: 'Invoice',
    iconKey: 'invoice',
    path: 'invoice'
  },

  {
    label: 'Commitment',
    iconKey: 'commitment',
    path: 'commitment'
  }
];

const ADMIN_LINKS = [
  {
    label: 'Dashboard',
    iconKey: 'dashboard',
    path: 'admin/dashboard'
  },
  {
    label: 'Subscriber',
    iconKey: 'subscriber',
    path: 'admin/subscribers'
  }
];

const WebSidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const currentUser = useAppSelector((state) => state.auth.currentUser);

  // Get the current path without the leading slash
  const currentPath = location.pathname.slice(1);
  console.log('currentPath', currentPath);
  console.log('location.pathname', location.pathname);

  const handleNavigation = (path: string) => {
    navigate(`/${path}`);
  };

  const isAdmin = currentUser?.roles?.includes('ADMIN');
  const links = isAdmin ? ADMIN_LINKS : USER_LINKS;

  const isLinkActive = (linkPath: string) => {
    // For exact match paths (like dashboard)
    if (currentPath === linkPath) {
      return true;
    }

    // For paths that should match sub-routes (like admin/subscribers)
    // Check if current path starts with the link path followed by a slash
    return currentPath.startsWith(linkPath + '/');
  };

  return (
    <aside className="w-[20%] md:max-w-[225px] md:min-w-[225px] lg:max-w-[260px] lg:min-w-[260px] pt-[3rem] bg-white shadow-[2px_0px_4px_0px_#00000040]">
      <img className="mx-auto w-[80px] h-[77px]" src={Logo} alt="Batjet Logo" />
      <section className="mt-10">
        {links.map((link) => (
          <SidebarLink
            key={link.path}
            label={link.label}
            iconKey={link.iconKey}
            isActive={isLinkActive(link.path)}
            onClick={() => handleNavigation(link.path)}
          />
        ))}
      </section>
    </aside>
  );
};

export default WebSidebar;
